import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.fmAccessHead')
    }
  }), _c(VRow, {
    staticClass: "pl-4 pb-4 pr-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm._l(_vm.accessItemsUI, function (item) {
    return _c(VCol, {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.accessItemsUI.length,
        expression: "accessItemsUI.length"
      }],
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4",
        "lg": "3",
        "xl": "2"
      }
    }, [_c('is-fm-door-card', {
      attrs: {
        "color": _vm.color,
        "favType": _vm.favType,
        "title": _vm.keyTwinTitle(item),
        "value": item.accessObjectData.title,
        "favUserId": _vm.sessionUserId,
        "favObjectId": item.id,
        "buttoncolor": _vm.color,
        "button": _vm.$i18n_t('Common.lockUnlock'),
        "status": _vm.$i18n_t('Common.doorStatus'),
        "sub-text": _vm.$i18n_t('Common.doorSubText'),
        "lock-id": item.accessObjectData.data.isFm.doorId,
        "isfmaccessid": item.id,
        "sub-icon": "fal fa-check",
        "icon": "fal fa-key",
        "access-key-dates": item.data
      }
    })], 1);
  }), _c(VCol, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.accessItemsUI.length,
      expression: "!accessItemsUI.length"
    }],
    attrs: {
      "cols": "12"
    }
  }, [_c(VIcon, {
    staticClass: "mr-1 stile-icon",
    attrs: {
      "color": _vm.color,
      "size": "20"
    }
  }, [_vm._v("fal fa-info-circle")]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('IS.FM.AccessMgmt.noKeys')) + "\n    ")], 1)], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };